"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 定制省市区组件
 * ** 重要
 * 必须在 targetForm 对象预留 PCD字段（用于form表单校验报错）
 * 必须传入省市区 6个key name，没有也要传
 * 外部数据保存的时候，PCD字段如果有必要，自行 delete targetForm.PCD
 */
var _default2 = exports.default = {
  name: 'FormCascader',
  props: {
    // 层级
    level: {
      type: Number,
      default: 3
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 挂载省市区字段的对象
    targetForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 省市区6字段的key
    keyList: {
      type: Array,
      default: function _default() {
        return ['region', 'regionCode', 'city', 'cityCode', 'district', 'districtCode'];
      }
    },
    // 返回的省市区是否要为数组regionCodeList/cityCodeList/districtCodeList
    returnArray: {
      type: Boolean,
      default: false
    },
    collapseTag: {
      type: Boolean,
      default: false
    },
    groupAll: {
      type: Boolean,
      default: false
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    // 插件props配置
    regionProps: {
      type: Object,
      default: function _default() {
        return {
          expandTrigger: 'hover'
        };
      }
    }
  },
  data: function data() {
    return {
      regionOptions: [] // 省市区
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = this.placeholder || this.$t('common.pleaseSelect');
      return this.isDisabled ? '' : txt;
    }
  },
  mounted: function mounted() {
    this.fetchRegionList(); // 省市区
  },
  methods: {
    /** 省市区 enum */fetchRegionList: function fetchRegionList() {
      var _this = this;
      var regionOptions = this.$store.getters.getRegionData("level_".concat(this.level));
      if (Array.isArray(regionOptions) && regionOptions.length) {
        this.regionOptions = regionOptions;
        return;
      }
      this.$api.common.getRegionList(this.level).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this.regionOptions = responseData.data || [];
          _this.$store.dispatch('baseData/saveRegionDataByLevel', {
            key: "level_".concat(_this.level),
            regionData: responseData.data || []
          });
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    /** 省市区选中 */onRegionChange: function onRegionChange() {
      var _this2 = this;
      // console.log(1111, this.keyList)
      this.$nextTick(function () {
        // console.log('=====keyList======', this.keyList)
        var keys = _this2.keyList || [];
        if (_this2.groupAll) {
          console.log(_this2.targetForm.PCD);
          var arr = [];
          var rtlRegionList = [];
          var rtlCityList = [];
          var rtlDistrictList = [];
          while (_this2.targetForm.PCD.some(function (item) {
            // console.log(item)
            if (rtlRegionList.indexOf(item[0]) === -1) {
              rtlRegionList.push(item[0]);
            }
            if (rtlCityList.indexOf(item[1]) === -1) {
              rtlCityList.push(item[1]);
            }
            if (rtlDistrictList.indexOf(item[2]) === -1) {
              rtlDistrictList.push(item[2]);
            }
            // eslint-disable-next-line no-empty
          })) {}
          arr.push(rtlRegionList);
          arr.push(rtlCityList);
          arr.push(rtlDistrictList);
          // console.log(arr)
          for (var i = 0; i < keys.length; i++) {
            _this2.setVal(keys[i], arr[i]);
          }
          // console.log(rtlCityList)
          // console.log(rtlDistrictList)
        } else {
          if (!_this2.$refs['region']) {
            console.log('还没初始化完成');
            return false;
          }
          var nodes = _this2.$refs['region'].getCheckedNodes();
          console.log(nodes);
          var node = nodes[0] || {};
          var _node$path = node.path,
            path = _node$path === void 0 ? [] : _node$path,
            _node$pathLabels = node.pathLabels,
            pathLabels = _node$pathLabels === void 0 ? [] : _node$pathLabels;
          console.log(path);
          _this2.setVal(keys[0], pathLabels[0]); // 省label
          _this2.setVal(keys[1], _this2.returnArray && path[0] ? [path[0]] : path[0]); // 省
          _this2.setVal(keys[2], pathLabels[1]); // 市label
          _this2.setVal(keys[3], _this2.returnArray && path[1] ? [path[1]] : path[1]); // 市
          if (_this2.level === 3) {
            _this2.setVal(keys[4], pathLabels[2]); // 区label
            _this2.setVal(keys[5], _this2.returnArray && path[2] ? [path[2]] : path[2]); // 区
          }
        }
      });
    },
    // 获取数据
    getVal: function getVal(key) {
      if (this.targetForm && key) {
        return this.targetForm[key] || '';
      } else {
        return '';
      }
    },
    // 外部数据赋值
    setVal: function setVal(key, val) {
      if (this.targetForm) {
        if (key) {
          this.targetForm[key] = val;
        }
      }
    }
  }
};